import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { faqs } from '../mock';

const FAQ = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contato');
    if (element) {
      const offset = 100; // Offset para melhor visualização
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-20 bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {faqs.map((faq) => (
            <Card
              key={faq.id}
              className="bg-gradient-to-br from-slate-800 to-slate-900 border-slate-700 hover:border-cyan-500 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/20 hover:-translate-y-2"
            >
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-white mb-3">{faq.question}</h3>
                <p className="text-gray-300 mb-6">{faq.answer}</p>
                <Button
                  onClick={scrollToContact}
                  className="w-full bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white font-semibold transition-all duration-300 hover:scale-105"
                >
                  Fale com um especialista
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;